export const CouponsTableColumns = [
    {
        id: "code",
        labelEn: "Code",
        labelAr: "الكود",
        align: "left",
        sortable: true,
    },
    {
        id: "type",
        labelEn: "Type",
        labelAr: "النوع",
        align: "center",
        sortable: true,
    },
    {
        id: "value",
        labelEn: "Value",
        labelAr: "القيمة",
        align: "center",
        sortable: true,
    },
    {
        id: "min_order_total",
        labelEn: "Min Order",
        labelAr: "الحد الأدنى",
        align: "center",
        sortable: true,
    },
    {
        id: "used_count",
        labelEn: "Used",
        labelAr: "المستخدم",
        align: "center",
        sortable: true,
    },
    {
        id: "is_active",
        labelEn: "Status",
        labelAr: "الحالة",
        align: "center",
        sortable: true,
    },
    {
        id: "ends_at",
        labelEn: "Ends At",
        labelAr: "تنتهي في",
        align: "center",
        sortable: true,
    },
];
